import HeroWithPartnerLogo from './HeroWithPartnerLogo'
export default HeroWithPartnerLogo
